import { Tour } from "nextstepjs";
import { TourType } from "~/types/tour";

export const tours: Tour[] = [
  {
    tour: TourType.ADD_ROTATION_BUTTON,
    steps: [
      {
        icon: <>👋</>,
        title: "Welcome to Pay checker - let’s get your pay right!",
        content: <>Take your first step by adding a rotation.</>,
        selector: '[data-cy="new_rotation_btn"]',
        side: "bottom-right",
        showControls: false,
        pointerPadding: 10,
        pointerRadius: 10,
      },
    ],
  },
  {
    tour: TourType.HOMEPAGE_OVERVIEW,
    steps: [
      {
        icon: <>🚀</>,
        title: "Getting started",
        content: (
          <>
            <p>To get your full pay report, you'll need:</p>
            <p style={{ marginTop: "8px", marginLeft: "16px" }}>
              • Your rota
              <br />
              • Your work schedule
              <br />• Your additional (personal) info
            </p>

            <p style={{ marginTop: "12px" }}>
              <strong>
                Each step may take a few minutes to complete, but once you've
                done this you're set.
              </strong>
            </p>
          </>
        ),
        //selector: '[data-cy="action-buttons-container"]',
        side: "bottom-left",
        showControls: true,
        showSkip: false,
        pointerPadding: 10,
        pointerRadius: 10,
      },
      {
        icon: <>📅</>,
        title: "Start with your rota",
        content: (
          <>
            You’ll need to input your rota for your whole rotation.
            <p style={{ marginTop: "12px" }}>
              It might be several months long, but we’ll use it to check your
              pay. This may take 5-10 minutes to do.
            </p>
            <p style={{ marginTop: "12px" }}>
              This will also generate your safe working check!
            </p>
          </>
        ),
        selector: '[data-cy="rota_btn"]',
        side: "bottom-left",
        showControls: true,
        showSkip: false,
        pointerPadding: 10,
        pointerRadius: 10,
      },
      {
        icon: <>📋</>,
        title: "Then work schedule",
        content: (
          <>
            You'll need to provide your current work schedule. This will be used
            to generate your payslips. You can compare to your actual payslips
            on the payslips tab.
          </>
        ),
        selector: '[data-cy="compws_dialog_btn"]',
        side: "bottom-left",
        showControls: true,
        showSkip: false,
        pointerPadding: 10,
        pointerRadius: 10,
      },
      {
        icon: <>📝</>,
        title: "Finally, input your additional information",
        content: (
          <>
            <p>
              You'll need to input some additional (personal) information that,
              with your rota, will generate your pay check.
            </p>
          </>
        ),
        selector: '[data-cy="advInfo_form_btn"]',
        side: "bottom-left",
        showControls: true,
        showSkip: false,
        pointerPadding: 10,
        pointerRadius: 10,
      },
    ],
  },
  {
    tour: TourType.ROTA_FIRST_SHIFT,
    steps: [
      {
        icon: <>✨</>,
        title: "Get started by adding a shift type",
        content: (
          <>
            <p>Add each shift type.</p>
            <br />
            <p>Get started by tapping here to create a shift.</p>
          </>
        ),
        selector: '[data-cy="new_shift_btn"]',
        side: "top-left",
        showControls: false,
        pointerPadding: 10,
        pointerRadius: 10,
      },
    ],
  },
  {
    tour: TourType.ROTA_ADD_TO_CALENDAR,
    steps: [
      {
        icon: <>📅</>,
        title: "Tap/click the shift type",
        content: (
          <>
            <p>
              Now you've created a shift, tap the shift you want to add to
              select it.
            </p>
            <br />
            <p>Then add the shift(s) to your calendar by tapping each day.</p>
          </>
        ),
        selector: '[data-cy^="shift_"]',
        side: "top-left",
        showControls: false,
        pointerPadding: 10,
        pointerRadius: 10,
      },
    ],
  },
];
